<mat-card class="cardWithShadow">
    <mat-card-content class="p-20">
        <div class="row justify-content-between gap-16">
            <div class="col-lg-4">
                <mat-form-field appearance="outline" class="w-100 hide-hint">
                    <input matInput placeholder="Search {{ 'ENTITY.WARD' | translate }}" [formControl]="searchWard">
                    <mat-icon matSuffix>
                        <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
                    </mat-icon>
                </mat-form-field>
            </div>
            <div class="col-lg-4 d-flex align-items-center justify-content-end">
                <button mat-flat-button color="primary" (click)="onAddWard()">
                    <mat-icon>add</mat-icon>
                    Add {{ 'ENTITY.WARD' | translate }}
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="cardWithShadow">
    <mat-card-content class="p-24">
        <div class="table-responsive table-scroll-container">
            <table mat-table [dataSource]="dataSource" class="w-100">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'ENTITY.WARD' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14 f-w-600">
                        <a (click)="onRowClick(element)" class="ipdLink">{{element.name}}</a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.CODE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        {{element.code | defaultValue}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="isActive">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.IS_ACTIVE' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="f-s-14">
                        <mat-icon class="check-checkbox-icon text-primary">
                            {{element.isActive ? 'check_box' : 'check_box_outline_blank'}}
                        </mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                        {{ 'LABEL.ACTION_LABEL' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="action-link" (click)="onActionClick($event)">
                        <a class="m-r-10 cursor-pointer" (click)="onUpdateWard(element)">
                            <i-tabler name="edit" class="icon-18"></i-tabler>
                        </a>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <div *ngIf="dataSource.data.length===0">
                <p class="text-center f-s-20 f-w-700 m-t-20">{{'LABEL.NO_DATA' | translate}}</p>
            </div>
            <mat-paginator class="paginator-fixed" [ngClass]="{'pointer-events-none': isLoading}"
                [length]="pagination.rowCount" [pageSize]="pagination.pageSize" [pageSizeOptions]="pageSizeOptions"
                [showFirstLastButtons]="true" [pageIndex]="pagination.currentPage">

            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>